import React, { FC } from 'react';

import TextField, { TextFieldProps } from './TextField';
import { Longdash } from '~/utils';
import { CheckmarkIcon } from '~/img';

const BooleanField: FC<TextFieldProps> = (props) => {
  const { label, children, ...rest } = props;
  return (
    <TextField label={label} {...rest}>
      {children ? <CheckmarkIcon /> : Longdash}
    </TextField>
  );
};

export default BooleanField;
